<div class="even">
<mat-label class="subHeading">Plan Type</mat-label>
<button class="side" (click)="form.controls['plan_type'].setValue(null)">Remove</button>
</div>
<mat-select class="plan" formControlName="plan_type" placeholder="All" [multiple]="isMultiSelect">
    <button
        *ngIf="isMultiSelect"
        class="btn selectAll"
        (click)="selectAll()"
    >
        Select All
    </button>
    <button
        *ngIf="isMultiSelect"
        class="btn selectAll"
        (click)="unSelectAll()"
    >
        Remove All
    </button>
    <mat-option value="floater">Floater</mat-option>
    <mat-option value="individual">Individual</mat-option>
</mat-select>